import { forwardRef } from "react";

import { SVGProps, Ref } from "react";

interface AISparkSvgProps extends SVGProps<SVGSVGElement> {
  title?: string;
  titleId?: string;
}

function AISparkSvg({ ...props }: AISparkSvgProps, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M18 13.5C18.092 13.5 18.1724 13.5613 18.197 13.6501C18.9698 16.4474 19.5519 17.0304 22.3499 17.803C22.4383 17.8275 22.5 17.908 22.5 18C22.5 18.092 22.4388 18.1725 22.3499 18.197C19.5524 18.9697 18.9697 19.5521 18.197 22.3499C18.1724 22.4387 18.092 22.5 18 22.5C17.908 22.5 17.8276 22.4387 17.803 22.3499C17.0302 19.5526 16.4481 18.9696 13.6501 18.197C13.5617 18.1725 13.5 18.092 13.5 18C13.5 17.908 13.5612 17.8275 13.6501 17.803C16.4476 17.0303 17.0303 16.4479 17.803 13.6501C17.8276 13.5613 17.908 13.5 18 13.5Z"
        fill="white"
      />
      <path
        d="M9.75 1.5C9.91868 1.5 10.0668 1.61239 10.1118 1.77539C11.5285 6.9038 12.5954 7.9718 17.7253 9.38818C17.8875 9.43319 18 9.58128 18 9.75C18 9.91872 17.8885 10.0668 17.7253 10.1118C12.5963 11.5284 11.5284 12.5952 10.1118 17.7246C10.0668 17.8876 9.91868 18 9.75 18C9.58132 18 9.43325 17.8876 9.38818 17.7246C7.97148 12.5962 6.90461 11.5282 1.77466 10.1118C1.61249 10.0668 1.5 9.91872 1.5 9.75C1.5 9.58128 1.61155 9.43319 1.77466 9.38818C6.90365 7.97164 7.97164 6.90476 9.38818 1.77539C9.43325 1.6124 9.58132 1.5 9.75 1.5Z"
        fill="white"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(AISparkSvg);
export default ForwardRef;
